module.exports = __webpack_public_path__ + "img/xcxm.147f28ad.png";